// A stored (picker) item keeps the full doc path under `content_path` (falling back to
// `CurrentPageURL` when no doc path was ever recorded), while a freshly-fetched gallery
// item's `CurrentPageURL` is only the trailing "/slug-timestamp" segment of that same
// path. Neither field lines up under strict equality, but the full path always ends
// with the short one, so match on that instead.
//
// A raw `endsWith` isn't enough though: it would also match two unrelated slugs where
// one merely ends with the other's characters (e.g. ".../sub-banner-123" ends with
// "banner-123" even though they're different items). Require the match to land on an
// actual path-segment boundary — either the shorter value already starts with "/" (the
// boundary is inside the compared suffix itself, the common case here), or the
// character immediately preceding the suffix in the longer value is "/".
const isPathSuffixMatch = (longer: string, shorter: string): boolean => {
  if (longer === shorter) return true;
  if (!longer.endsWith(shorter)) return false;
  if (shorter.startsWith("/")) return true;
  const boundaryIndex = longer.length - shorter.length - 1;
  return boundaryIndex >= 0 && longer[boundaryIndex] === "/";
};

export const isSameGalleryItem = (storedItem: any, liveItem: any): boolean => {
  const storedPath = storedItem?.content_path || storedItem?.CurrentPageURL || "";
  const livePath = liveItem?.CurrentPageURL || "";
  if (!storedPath || !livePath) return false;
  return isPathSuffixMatch(storedPath, livePath) || isPathSuffixMatch(livePath, storedPath);
};
